import React from "react";
import FlexBox from "components/FlexBox/FlexBox";
import ParticipantQualificationLicenseIdInput from "components/ParticipantEditDialog/ParticipantQualificationLicenseIdInput";

type DefaultQualificationFormProps = {};

const DefaultQualificationForm: React.FC<DefaultQualificationFormProps> = () => {
  return (
    <FlexBox direction={"column"} spacing={4}>
      <ParticipantQualificationLicenseIdInput isRequired={true} />
    </FlexBox>
  );
};

export default DefaultQualificationForm;
